import { render, staticRenderFns } from "./MaterialTable.vue?vue&type=template&id=578ca1ac&scoped=true&"
import script from "./MaterialTable.vue?vue&type=script&lang=js&"
export * from "./MaterialTable.vue?vue&type=script&lang=js&"
import style0 from "./MaterialTable.vue?vue&type=style&index=0&id=578ca1ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578ca1ac",
  null
  
)

export default component.exports